import React from 'react';
import moment, { Moment } from 'moment';
import DatePicker from 'react-datepicker';
import classNames from 'classnames';
import { CalendarIcon } from 'components/icons';

interface CustomDatePickerProps {
	onChange: (d: Moment, n: string) => void;
	id: string;
	label: string;
	required?: boolean;
	error?: string;
	hintText?: string;
	name: string;
	monthsShown?: number;
	disabled?: boolean;
	value?: Moment;
	readOnly?: boolean;
	minDate?: Moment;
	maxDate?: Moment;
}

export const CustomDatePicker = ({
	id,
	label,
	required = false,
	error,
	hintText,
	name,
	onChange,
	monthsShown = 1,
	value,
	disabled = false,
	readOnly = false,
	minDate,
	maxDate,
}: CustomDatePickerProps) => {
	function handleChange(d: Date | null) {
		onChange(moment(d), name);
	}

	return (
		<div
			className={classNames(
				'group group--datepicker row',
				value ? 'group--filled' : 'group--empty',
			)}
		>
			<CalendarIcon iconClass="group__icon" />
			<DatePicker
				selected={value ? value.toDate() : null}
				onChange={handleChange}
				className="group__datepicker"
				monthsShown={monthsShown}
				autoComplete="off"
				dateFormat="yyyy/MM/dd"
				strictParsing
				required={required}
				disabled={disabled}
				readOnly={readOnly}
				minDate={minDate?.toDate()}
				maxDate={maxDate?.toDate()}
				shouldCloseOnSelect
			/>
			<div
				className="group__label-bg"
				data-label={required ? `${label}*` : label}
			/>
			<label className="group__label" htmlFor={id}>
				{required ? `${label}*` : label}
			</label>
			<p
				className={`group__hint font-caption
					${error ? 'group__hint--error' : ''}`}
			>
				{error || hintText}
			</p>
		</div>
	);
};
